import fetchClient from '@/lib/fetch'
import type { V1WhiteLabelDataType } from '@/types/global-data'

export const WHITE_LABEL_QUERY_KEY = 'white-label'
export async function getWhiteLabelData(programId?: string | null): Promise<V1WhiteLabelDataType> {
  const url = programId ? `/v1/data/app?programId=${programId}` : '/v1/data/app'
  return fetchClient(url, { method: 'GET' })
}
